import { tryAddMultipleRefinements } from '../multipleRefinementsUtils';
import { defaultUtmParameters, getUtmParameters, getUrlBase } from '../../../utils/urlUtils';
const fromPageViewOperation = (Operator, field, filter) => {
  const {
    enableTracking,
    pageUrl
  } = filter;
  const utmBase = enableTracking ? getUrlBase(pageUrl) : '';
  const utmParameters = enableTracking ? getUtmParameters(pageUrl) : defaultUtmParameters;
  const operator = Operator.of(field, pageUrl, enableTracking, utmBase, utmParameters);
  return tryAddMultipleRefinements(operator, field, filter);
};
export { fromPageViewOperation };